/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Brazilian Portuguese (pt) string table — Shop landing page
   English is the source of truth in the HTML; this file supplies the
   Portuguese counterpart for each shop.* key. Missing keys fall back to
   English (see i18n.js). Claim-bearing copy: faithful renderings only,
   no strengthening or embellishment. The only standing discount is the
   routine-builder 10% (auto-applied at checkout for 2+ serums).

   Brazilian Portuguese (pt-BR), not European. Use "você", gerund tenses,
   BR vocabulary (hidratante, tela, geladeira). No em dashes in prose
   (use periods, commas, or the mid-dot · ). EXCEPTION: combo card labels
   keep the existing em dash ("Serum C — Brightening"), mirrored
   faithfully. Standalone "serum" → "sérum".
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.pt = window.TD_I18N.pt || {};
  Object.assign(window.TD_I18N.pt, {

    /* ── Nav (page-specific) ── */
    'shop.nav.build': 'Monte uma rotina',

    /* ── Serum grid ── */
    'shop.grid.title': 'Skincare sem compromissos',
    'shop.addcart': 'Adicionar ao carrinho',
    'shop.time.day': 'Dia',
    'shop.time.night': 'Noite',
    'shop.time.both': 'Dia e noite',
    'shop.card.c.benefit': 'Protege, ilumina e firma com vitamina C pura.',
    'shop.card.a.benefit': 'Renovação conduzida pelo retinol enquanto você dorme.',
    'shop.card.o.benefit': 'Dá energia às células e restaura a luminosidade visível.',
    'shop.card.m.benefit': 'Repara a barreira de hidratação. Profunda e duradoura.',
    'shop.card.r.benefit': 'Firma e restaura. Reduz imperfeições e textura desigual ao longo do tempo.',

    /* ── Benefit strip ── */
    'shop.strip.1.t': 'Sem conservantes',
    'shop.strip.1.b': 'Embalagem airless e resistente aos UV que protege cada ativo. Sem estabilizantes, sem compromissos.',
    'shop.strip.2.t': 'Liberação transdérmica',
    'shop.strip.2.b': 'Um sistema portador sem água transporta as vitaminas ativas além da superfície até a derme, onde a síntese de colágeno e a renovação celular acontecem.',
    'shop.strip.3.t': '2 anos de validade',
    'shop.strip.3.b': 'Sem água significa sem crescimento bacteriano. Estável e potente do primeiro ao último uso.',
    'shop.strip.4.t': 'Cruelty-free',
    'shop.strip.4.b': 'Nunca testado em animais. Desenvolvido clinicamente, entregue de forma responsável.',

    /* ── Combo builder ── */
    'shop.combo.label': 'Monte sua rotina',
    'shop.combo.h2': 'Dois sérums ou mais?<br><em>Dez por cento de desconto.</em>',
    'shop.combo.c.name': 'Serum C — Luminosidade',
    'shop.combo.c.desc': 'Vitamina C · Dia · Manchas escuras e luminosidade',
    'shop.combo.a.name': 'Serum A — Renovação',
    'shop.combo.a.desc': 'Vitamina A · Noite · Renovação celular e textura',
    'shop.combo.o.name': 'Serum O — Oxigenante',
    'shop.combo.o.desc': 'Vitamina O · Dia · Vitalidade celular e tom',
    'shop.combo.m.name': 'Serum M — Hidratação',
    'shop.combo.m.desc': 'Vitamina M · Dia + noite · Hidratação e barreira',
    'shop.combo.r.name': 'Serum R — Antioxidante',
    'shop.combo.r.desc': 'Resveratrol · Dia + noite · Proteção e longevidade',

    /* ── Combo summary sidebar ── */
    'shop.concern.label': 'Compre pela necessidade da pele',
    'shop.concern.placeholder': 'Escolha uma necessidade…',
    'shop.concern.firmness': 'Firmeza',
    'shop.concern.brightness': 'Luminosidade',
    'shop.concern.hydration': 'Hidratação',
    'shop.concern.finelines': 'Linhas finas',
    'shop.concern.darkspots': 'Manchas escuras',
    'shop.concern.texture': 'Textura',
    'shop.concern.acnescars': 'Cicatrizes de acne',
    'shop.concern.dullness': 'Tom sem brilho',
    'shop.sum.title': 'Sua rotina',
    'shop.sum.empty': 'Escolha sérums para começar',
    'shop.sum.discount': 'Desconto rotina (10%)',
    'shop.sum.total': 'Total',
    'shop.sum.addbtn': 'Adicionar a rotina ao carrinho',
    'shop.sum.note': 'Frete grátis para o mundo todo · 2 anos de validade garantidos',

    /* ── Sample / Discovery Kit ── */
    'shop.samp.eyebrow': 'Não sabe por onde começar?',
    'shop.samp.title': 'Experimente os cinco<br><em>por $70.</em>',
    'shop.samp.body': 'O Transderma Discovery Kit contém versões em tamanho de bolso dos cinco sérums. Foi assim que a maioria dos nossos clientes de longa data nos conheceu.',
    'shop.samp.cta': 'Garanta o Discovery Kit',
    'shop.samp.fine': '$5 de frete para o mundo todo · Enviado de Stockholm',
    'shop.samp.f1.t': 'Os cinco sérums',
    'shop.samp.f1.b': 'Versões em tamanho de bolso de C, A, O, M e R, 3 ml cada. Cerca de 7 dias de uso regular por frasco.',
    'shop.samp.f2.t': 'Os cinco, lado a lado',
    'shop.samp.f2.b': 'Faça cada fórmula passar pela sua rotina na mesma semana e descubra as combinações que funcionam para a sua pele.',
    'shop.samp.f3.t': 'Sem compromisso',
    'shop.samp.f3.b': 'Você saberá em uma semana se a Transderma é para você. A maioria sabe em poucos dias.',

    /* ── Gift voucher ── */
    'shop.gift.title': 'Presenteie <em>Transderma</em>',
    'shop.gift.sub': 'Um vale digital entregue por e-mail. Utilizável em cada sérum e no Discovery Kit.',
    'shop.gift.btn': 'Comprar agora',

    /* ── Discovery Kit product page (shopify-theme/templates/product.transderma-discovery-kit.liquid) ── */
    'shop.kit.crumb.home': 'Início',
    'shop.kit.crumb.current': 'Discovery Kit',

    /* Hero */
    'shop.kit.eyebrow': 'Cinco sérums vitamínicos · Um kit',
    'shop.kit.tagline': 'Versões em tamanho de bolso dos cinco sérums Transderma. Cerca de 7 dias de uso diário para o kit inteiro. Experimente o sistema completo antes de decidir pelos frascos em tamanho grande.',
    'shop.kit.price.meta': 'Cinco mini-frascos · 3 ml cada',
    'shop.kit.addcart': 'Adicionar ao carrinho · $70',
    'shop.kit.soldout': 'Esgotado · em breve de volta',
    'shop.kit.reserve': 'Reserve seu kit',

    /* Hero meta */
    'shop.kit.meta.inside': 'O que tem dentro',
    'shop.kit.meta.inside.v': '5 mini-frascos · 3 ml cada',
    'shop.kit.meta.lasts': 'Duração',
    'shop.kit.meta.lasts.v': '~7 dias de uso diário',
    'shop.kit.meta.formula': 'Fórmula',
    'shop.kit.meta.formula.v': '100% ativo, sem água',
    'shop.kit.meta.shelf': 'Validade',
    'shop.kit.meta.shelf.v': '2 anos, potente do início ao fim',

    /* What's inside */
    'shop.kit.inside.label': 'O que tem dentro',
    'shop.kit.inside.title': 'Cinco mini-frascos.<br><em>Uma rotina completa.</em>',
    'shop.kit.inside.intro': 'Cada mini-frasco contém sérum suficiente para cerca de 7 dias de aplicação diária. Use-os separadamente, sobreponha de manhã e à noite, ou teste combinações conforme as suas necessidades.',
    'shop.kit.card.time.day': 'Dia',
    'shop.kit.card.time.night': 'Noite',
    'shop.kit.card.time.both': 'Dia + noite',
    'shop.kit.card.c.desc': 'Vitamina C pura. Ilumina, protege, uniformiza o tom.',
    'shop.kit.card.a.desc': 'Retinol. Renovação celular e textura, enquanto você dorme.',
    'shop.kit.card.o.desc': 'PQQ. Energia celular, vitalidade, clareza.',
    'shop.kit.card.m.desc': 'Ácido hialurônico. Hidratação, preenchimento, suporte da barreira.',
    'shop.kit.card.r.desc': 'Resveratrol. Defesa antioxidante e longevidade.',

    /* Why try the kit */
    'shop.kit.why.label': 'Por que começar aqui',
    'shop.kit.why.title': 'Encontre a sua rotina <em>antes</em> de se comprometer.',
    'shop.kit.why.intro': 'Um frasco em tamanho grande custa $175 e dura várias semanas de uso diário. O Discovery Kit é a maneira mais simples de saber quais sérums funcionam na sua pele, e quais combinações realmente fazem diferença para as suas necessidades específicas.',
    'shop.kit.why.1.t': '~7 dias de uso real.',
    'shop.kit.why.1.b': 'Sérum suficiente para aplicar de manhã e à noite por cerca de uma semana e começar a ver mudanças de textura, tom e hidratação. Não é uma amostra, é uma rotina em andamento.',
    'shop.kit.why.2.t': 'Os cinco, lado a lado.',
    'shop.kit.why.2.b': 'Faça cada fórmula passar pela sua rotina da manhã e da noite na mesma semana. O kit é a maneira mais rápida de aprender quais combinações realmente fazem diferença para a sua pele.',
    'shop.kit.why.3.t': 'Os cinco por menos da metade de um frasco.',
    'shop.kit.why.3.b': 'Um único sérum Transderma em tamanho grande custa $175. O kit te dá os cinco por $70: a maneira mais econômica de saber a quais fórmulas a sua pele realmente responde antes de decidir.',

    /* How it works */
    'shop.kit.how.label': 'Como funciona',
    'shop.kit.how.title': 'Sete dias. <em>Uma descoberta.</em>',
    'shop.kit.how.intro': 'A maioria dos clientes sabe em cinco dias. Veja o caminho que a maioria segue.',
    'shop.kit.how.s1.t': 'Dia 1 · Abra',
    'shop.kit.how.s1.b': 'Abra o kit. Escolha a necessidade que corresponde à sua: luminosidade, renovação ou hidratação.',
    'shop.kit.how.s2.t': 'Dias 1 a 3 · Teste',
    'shop.kit.how.s2.b': 'Aplique sua rotina de manhã e à noite. Duas gotas, pressionadas em pele limpa. Deixe cada camada absorver por 30 segundos.',
    'shop.kit.how.s3.t': 'Dias 4 a 7 · Ajuste',
    'shop.kit.how.s3.b': 'Ao sétimo dia, você saberá a quais sérums sua pele responde. Mude a rotina, sobreponha de outra forma, ou simplifique para dois.',
    'shop.kit.how.s4.t': 'Dia 8 · Aumente a escala',
    'shop.kit.how.s4.b': 'Encomende frascos em tamanho grande dos sérums que funcionaram, na rotina que você construiu. Dois frascos ou mais = 10% de desconto.',

    /* Delivery / returns */
    'shop.kit.del.shipping.t': 'Frete',
    'shop.kit.del.shipping.b': 'Tarifa única de $5 de frete para o mundo todo. Enviado de Stockholm, geralmente em 3 a 7 dias úteis. <a href="/pages/shipping-returns">Detalhes completos de frete</a>.',
    'shop.kit.del.returns.t': 'Devoluções',
    'shop.kit.del.returns.b': 'Uma vez aberto, o Discovery Kit não é reembolsável. Kits não abertos podem ser devolvidos em até 14 dias. <a href="/pages/shipping-returns">Política de devoluções</a>.',
    'shop.kit.del.approved.t': 'Aprovado e registrado',
    'shop.kit.del.approved.b': 'Aprovado em laboratório pelo Läkemedelsverket. Registrado conforme a legislação europeia sobre cosméticos. Nunca testado em animais.'

  });
})();
